module.exports = __webpack_public_path__ + "static/media/sync-frequency-banner.bf271878.png";